import * as types from '../mutation-types'

const state = {
  step: 0
}

const mutations = {
  [types.PREV_STEP] (state) {
    if (state.step > 0) {
      state.step--
    }
  },
  [types.NEXT_STEP] (state) {
    if (state.step < 5) {
      state.step++
    }
  },

  [types.GO_STEP] (state, step) {
    if (step >= 0 && step <= 5) {
      state.step = step
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/step.js